<ppl-app-container [showCopyright]="false">
  <div class="align-in-center">
    @if (isEmailVerified$ | async) {
      <ppl-email-verification-verification-complete (login)="onLogin()"></ppl-email-verification-verification-complete>
    } @else {
      <ppl-email-verification-verification-needed
        [email]="email$ | async"
        [error]="emailVerificationError$ | async"
        [loading]="resendingVerificationEmail$ | async"
        (resendEmail)="onResendEmail()"></ppl-email-verification-verification-needed>
    }
  </div>
</ppl-app-container>
